import * as React from "react";
import { ReactNode } from "react";

interface MultiStepFormProps {
  children: ReactNode;
  currentStep: number;
}

// LongTermFix 16/12/20 sjahan: This component must be removed. The only purpose of this is now displaying the steps, and it must be simplifying accordingly. It still handles the display of the steps...
export default class MultiStepForm extends React.Component<MultiStepFormProps> {
  render() {
    const children = React.Children.toArray(this.props.children).filter((v) => v) as ReactNode[];
    return (
      <div className="react-form">
        <div className="h-flex steps centered">
          {children.map((child, index) => {
            const content = index < this.props.currentStep ? <i className="ic_check" /> : index + 1;
            return typeof child["type"] === "function" ? (
              <div
                key={index}
                className={
                  "h-flex centered" +
                  (index < this.props.currentStep
                    ? " done"
                    : index == this.props.currentStep
                      ? " active"
                      : "")
                }
              >
                {content}
              </div>
            ) : null;
          })}
        </div>
        {children.map((child, index) => (
          <div
            key={index}
            className={index == this.props.currentStep ? "multistep-wrapper" : "none"}
          >
            {child}
          </div>
        ))}
      </div>
    );
  }
}
